var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.66699L9 10.167L6.5 7.66699",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1C8.01509 1 7.03982 1.19399 6.12987 1.5709C5.21993 1.94781 4.39314 2.50026 3.6967 3.1967C3.00026 3.89314 2.44781 4.71993 2.0709 5.62987C1.69399 6.53982 1.5 7.51509 1.5 8.5C1.5 9.48491 1.69399 10.4602 2.0709 11.3701C2.44781 12.2801 3.00026 13.1069 3.6967 13.8033C4.39314 14.4997 5.21993 15.0522 6.12987 15.4291C7.03982 15.806 8.01509 16 9 16C10.9891 16 12.8968 15.2098 14.3033 13.8033C15.7098 12.3968 16.5 10.4891 16.5 8.5C16.5 6.51088 15.7098 4.60322 14.3033 3.1967C12.8968 1.79018 10.9891 1 9 1Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.937db8dc685dcf95757c02e190a86b7f.svg";
export { ForwardRef as ReactComponent };